import React from 'react';
import { Select, Form, FormInstance } from 'antd';
import { t } from 'i18next';
import { COMPRESSOR_DATA, ModelSpec, ROOMS, NO_MATCHING_SPEC } from '@/store/SiteSurveyForm/constants';

interface ModelSpecSelectProps {
  roomId: number;
  compressorId: string;
  index: number;
  pressureType: string;
  roomIndex: number;
  modelSpecs: ModelSpec[];
  form: FormInstance;
  initialValue?: string;
  onNoMatchingSpecSelect?: () => void;
}
export const ModelSpecSelect: React.FC<ModelSpecSelectProps> = ({
  index,
  pressureType,
  roomIndex,
  modelSpecs,
  form,
  initialValue,
  onNoMatchingSpecSelect,
}) => {
  const fieldName = [pressureType, ROOMS, roomIndex, COMPRESSOR_DATA, index, 'modelSpec'];
  const technicalNameField = [pressureType, ROOMS, roomIndex, COMPRESSOR_DATA, index, 'modelSpecTechnicalName'];

  return (
    <Form.Item
      name={fieldName}
      className="model-spec-select"
      initialValue={initialValue}
      preserve={true}
      shouldUpdate={(prevValues, currentValues) => {
        const prevRoomData = prevValues?.[pressureType]?.rooms?.[roomIndex];
        const currentRoomData = currentValues?.[pressureType]?.rooms?.[roomIndex];
        return prevRoomData !== currentRoomData;
      }}
    >
      <Select
        placeholder={t('Model spec')}
        className="model-spec-select"
        options={modelSpecs}
        showSearch
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.modelDisplayName as string).toLowerCase().includes(input.toLowerCase())
        }
        onChange={value => {
          const modelSpec = modelSpecs.find(spec => spec.id === value);
          form.setFieldValue(technicalNameField, modelSpec?.technicalName || 'No data');
  
          if (value === NO_MATCHING_SPEC && onNoMatchingSpecSelect) {
            onNoMatchingSpecSelect();
          }
        }}
      />
    </Form.Item>
  );
};
